export const convertTo12Hour = (time24) => {
  if (!time24) return "N/A";
  
  try {
    const [hours, minutes] = time24.split(':');
    let hour = parseInt(hours);
    const minute = minutes || '00';
    const ampm = hour >= 12 ? 'PM' : 'AM';
    
    hour = hour % 12;
    hour = hour ? hour : 12; // 0 should be 12
    
    return `${hour}:${minute} ${ampm}`;
  } catch (error) {
    console.error('Time conversion error:', error);
    return time24; // Return original if conversion fails
  }
};

/**
 * Format date and time together
 * @param {string} date - Date string
 * @param {string} time24 - Time in 24-hour format
 * @returns {string} - Formatted date and time
 */
export const formatDateTime = (date, time24) => {
  const formattedTime = convertTo12Hour(time24);
  return `${date} at ${formattedTime}`;
};

/**
 * Get current time in 12-hour format
 * @returns {string} - Current time (e.g., "3:45 PM")
 */
export const getCurrentTime12Hour = () => {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  
  return `${hour12}:${minutes} ${ampm}`;
};